"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ToggleButton = _interopRequireDefault(require("./ToggleButton"));

var _colors = require("../../config/colors");

var _config = require("../../config/config");

var DetailsAccordion = function DetailsAccordion(_ref) {
  var isOpen = _ref.isOpen,
      accordionToggle = _ref.accordionToggle,
      accordionName = _ref.accordionName,
      accordionContent = _ref.accordionContent;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Accordion, {
      defaultActiveKey: "1",
      "data-cy": "accordion-" + accordionName
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card, {
      style: {
        backgroundColor: _colors.SIDEBAR_BACKGROUND_COLOR
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Accordion.Toggle, {
      as: _reactBootstrap.Card.Header,
      eventKey: "1",
      onClick: accordionToggle,
      className: "d-block",
      role: "list"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Row, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Col, {
      md: 10
    },
    /*#__PURE__*/
    _react["default"].createElement("h4", {
      className: "sidebar-heading text-dark",
      style: {
        fontSize: '18px',
        letterSpacing: _config.ACCORDION_LETTER_SPACING,
        fontWeight: _config.ACCORDION_LETTER_WEIGHT
      }
    }, accordionName),
    /*#__PURE__*/
    _react["default"].createElement("hr", {
      className: "m-0 bg-primary",
      style: {
        height: '2px',
        width: '12%'
      }
    })),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Col, {
      md: 2
    },
    /*#__PURE__*/
    _react["default"].createElement(_ToggleButton["default"], {
      isOpen: isOpen
    })))),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Accordion.Collapse, {
      eventKey: "1",
      role: "listitem",
      "data-testid": "accordion-" + accordionName + "-content"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Body, null, accordionContent))))
  );
};

DetailsAccordion.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: _propTypes["default"].bool.isRequired,
  accordionToggle: _propTypes["default"].func.isRequired,
  accordionName: _propTypes["default"].string.isRequired,
  accordionContent: _propTypes["default"].element.isRequired
} : {};

var _default = exports["default"] = DetailsAccordion;